/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable import/no-unresolved, import/default */

import editAerationTemplate from './edit-aeration.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.admin.editAeration', [])
    .directive('agEditAeration', EditAeration)
    .name;

/*@ngInject*/
function EditAeration() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            aerationId: '=',
            assetId: '='
        },
        controller: EditAerationController,
        controllerAs: 'vm',
        templateUrl: editAerationTemplate
    };
}

/* eslint-disable angular/angularelement */


/*@ngInject*/
function EditAerationController($rootScope, $scope, $timeout, $translate, agTypes, userService, aerationService) {

    let vm = this;

    vm.agTypes = agTypes;

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN';
    vm.aeration = null;

    vm.save = save;
    vm.cancel = cancel;

    $scope.$watch('vm.aerationId', function() {
        if (vm.showData) {
            reload(vm.aerationId);
        }
    });

    function reload(aerationId) {
        if (!vm.aeration || !angular.equals(vm.aeration.id, aerationId)) {
            vm.loading = true;
            vm.origAeration = null;
            vm.aeration = null;
            if (aerationId) {
                aerationService.getAeration(aerationId).then(
                    function success(aeration) {
                        vm.origAeration = aeration;
                        vm.aeration = angular.copy(aeration);
                        vm.loading = false;
                        resetFormState();
                    }
                );
            } else {
                vm.loading = false;
            }
        }
    }

    function resetFormState() {
        $timeout(function() {
            $scope.theForm.$setPristine();
            $scope.theForm.$setUntouched();
        });
    }

    function cancel() {
        vm.aeration = angular.copy(vm.origAeration);
        resetFormState();
    }

    function save() {
        aerationService.saveAssetAeration(vm.aeration, vm.assetId).then(function success(aeration) {
            vm.origAeration = aeration;
            vm.aeration = angular.copy(aeration);
            $scope.theForm.$setPristine();
            $scope.theForm.$setUntouched();
            $rootScope.$broadcast('aerationUpdated', vm.origAeration);
        });
    }

}

